<template>
  <div class="main-wrapper">
    <el-card class="box-card">
      <slot name="header" class="clearfix">
        <span>错误信息</span>
      </slot>
      <el-divider style="border-top: 1px solid #ef5350 !important; border-radius: 3px"></el-divider>
      <div class="text">
        <p style="word-wrap: break-word; font-size: 14px; line-height: 22px;" v-html="message" v-if="message"></p>
        <p style="word-wrap: break-word; font-size: 14px; line-height: 22px;" v-html="stackTrace" v-if="stackTrace"></p>
        <p style="word-wrap: break-word; font-size: 14px; line-height: 22px;" v-html="addDate" v-if="addDate"></p>
      </div>
    </el-card>
  </div>
</template>

<script lang="ts">
import utils from '@/utils';
import api from '@/api/error';
import { defineComponent } from 'vue';

interface IState {
  logId: number,
  uuid: string,
  message: string | null,
  stackTrace: string,
  addDate: Date,
}

export default defineComponent({
  data() {
    return {
      logId: utils.toInt(this.$route.query.logId),
      uuid: this.$route.query.uuid,
      message: this.$route.query.message,
      stackTrace: '',
      addDate: new Date(),
    } as IState;
  },
  methods: {
    apiGet() {
      api.get(this.logId, (res) => {
        this.message = `${res.error.summary} ${res.error.message}`;
        this.stackTrace = res.error.stackTrace;
        this.addDate = res.error.addDate;
      });
    },
  },
  mounted() {
    if (this.logId > 0) {
      this.apiGet();
    } else if (this.uuid) {
      this.message = sessionStorage.getItem(this.uuid);
    }
    utils.loading(false);
  },
});
</script>
